import { useState, useEffect, useCallback } from 'react';
import { getSettingsRepository } from '../../../main/factories/settings-dependencies.factory';
import { SocialPostDTO } from '../../../infrastructure/repositories/http-settings.repository';

export const useSocialPosts = () => {
  const [posts, setPosts] = useState<SocialPostDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const settingsRepo = getSettingsRepository();

  const loadPosts = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await settingsRepo.getLatestSocialPosts();
      setPosts(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar publicaciones de redes sociales');
    } finally {
      setLoading(false);
    }
  }, [settingsRepo]);

  useEffect(() => {
    loadPosts();
  }, [loadPosts]);

  return {
    posts,
    loading,
    error,
    refresh: loadPosts,
  };
};
